import styled from 'styled-components'

export default styled.div`
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
`
